<template>
    <!--新增界面-->
    <div v-if="formVisible">
        <el-dialog v-dragDialog :title="formTitle" :visible.sync="formVisible" width="500px"
            :close-on-click-modal="false">
            <el-form :model="addForm" ref="dataForm" label-width="130px" :rules="formRules">
                <el-form-item label="跑团名称:" prop="Name">
                    <el-input v-model="addForm.Name" auto-complete="off" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="是否启用:" prop="IsEnabled">
                    <el-switch v-model="addForm.IsEnabled"></el-switch>
                </el-form-item>
                <el-form-item label="备注:" prop="Desc">
                    <el-input v-model="addForm.Desc" auto-complete="off" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="formVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmit">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Save } from "@/api/traning/runGroup";
export default {
    components: {
    },
    data() {
        return {
            formVisible: false,
            fromTitle: "添加跑团",
            addForm: {},
            formRules: {
                Name: [{ required: true, message: "请输入名称", trigger: "change" }],
            },
        };
    },
    methods: {
        handleCreate() {
            this.formTitle = "添加跑团";
            this.formVisible = true;
            this.addForm = {
                Name: "",
                IsEnabled: true,
                Desc: "",
            };
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        handleUpdate(row) {
            this.addForm = JSON.parse(JSON.stringify(row));
            this.formTitle = "修改跑团";
            this.formVisible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        handleSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let para = Object.assign(this.addForm);
                    this.$confirm("确认提交吗？", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                    }).then(() => {
                        Save(para).then((response) => {
                            if (response) {
                                this.formVisible = false;
                                this.$emit("update")
                            }
                        });
                    });
                }
            });
        },
    },
    mounted() {
    },
};
</script>